import * as React from "react";
import SvgIcon, { SvgIconProps } from "material-ui/SvgIcon";

export class MetropolisShortLogo extends React.Component<
  SvgIconProps,
  undefined
> {
  render() {
    const props = Object.assign(
      { viewBox: "0 0 907.1 411", color: "black" },
      this.props,
    );

    return (
      <SvgIcon {...props}>
        <path d="M0 0H907.1V411H0z" />
        <path fill="#fff" d="M29.2 29.2H879.6V380.59999999999997H29.2z" />
        <path d="M167.6 101.3L102.1 101.3 102.1 308.8 247.8 308.8 247.8 257.5 167.6 257.5z" />
        <path d="M441.2 228.6L404.1 101.3 337.1 101.3 406.5 308.8 474.9 308.8 545.2 101.3 477.9 101.3z" />
        <path d="M623.6 227.5L715 227.5 715 182.5 623.9 182.5 623.9 152.7 731 152.7 731 101.3 558.1 101.3 558.1 308.8 731.2 308.8 731.2 257.5 623.6 257.5z" />
        <path d="M747.3 257.4H807.8V308.79999999999995H747.3z" />
        <path d="M747.3 101.3H807.8V241.2H747.3z" />
        <path d="M263.6 168.8H324.1V308.70000000000005H263.6z" />
        <path d="M263.6 101.3H324.1V152.7H263.6z" />
      </SvgIcon>
    );
  }
}

export default MetropolisShortLogo;



// WEBPACK FOOTER //
// ./src/themes/metropolis/components/MetropolisShortLogo.tsx